import { useSearchParams } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";
import { Container } from "@/components/common/ui";
import { EnquiryForm } from "@/components/forms/EnquiryForm";
import { HomeMap } from "@/components/map/HomeMap";
import { SITE } from "@/lib/site";

const Card = ({ Icon, title, children, testId }) => (
  <div className="rounded-md border border-neutral-200 p-5" data-testid={testId}>
    <Icon className="h-5 w-5 text-brass-deep" />
    <p className="mt-3 text-[13px] uppercase tracking-[0.16em] text-neutral-500">{title}</p>
    <div className="mt-1 text-[16px] text-ink">{children}</div>
  </div>
);

export default function ContactPage() {
  const [sp] = useSearchParams();
  const career = sp.get("kind") === "career";
  return (
    <div className="py-14 sm:py-20" data-testid="contact-page">
      <Container className="grid gap-12 lg:grid-cols-[1fr_1.1fr]">
        <div>
          <p className="eyebrow">Contact</p>
          <h1 className="mt-4 font-display text-5xl font-normal leading-[1.05] sm:text-6xl">Contact The Rob Resh Team</h1>
          <p className="mt-5 max-w-lg text-[17px] text-neutral-600">
            Please understand that our job is to make sure you have all the information you need at the time you need it. Feel free to contact our team at any time.
          </p>
          <div className="mt-8 grid gap-4 sm:grid-cols-2">
            <Card Icon={Phone} title="Call" testId="contact-phone-card">
              <a href={SITE.phoneMainHref} className="block hover:underline" data-testid="contact-phone-main">{SITE.phoneMain}</a>
              <a href={SITE.phoneOfficeHref} className="block text-[14px] text-neutral-600 hover:underline" data-testid="contact-phone-office">Office {SITE.phoneOffice}</a>
            </Card>
            <Card Icon={Mail} title="Email" testId="contact-email-card">
              <a href={`mailto:${SITE.email}`} className="break-all hover:underline" data-testid="contact-email">{SITE.email}</a>
            </Card>
            <Card Icon={MapPin} title="Office" testId="contact-office-card">
              <p>{SITE.officeName}</p><p className="text-[14px] text-neutral-600">{SITE.street}<br />{SITE.cityLine}</p>
              <a href={SITE.directionsUrl} target="_blank" rel="noreferrer" className="mt-2 inline-block text-[14px] underline underline-offset-4" data-testid="contact-directions">Get directions</a>
            </Card>
          </div>
          <div className="mt-6 h-[300px] overflow-hidden rounded-md">
            <HomeMap testId="contact-map" office={SITE.office} initialMode="streets" controls={false}
              initialView={{ center: [SITE.office.lng, SITE.office.lat], zoom: 14.5, pitch: 45, bearing: -20 }} />
          </div>
        </div>
        <div className="rounded-md border border-neutral-200 p-6 sm:p-8 lg:self-start">
          <h2 className="text-2xl font-normal">{career ? "Interested in a career with us?" : "Have a question or want a free market report?"}</h2>
          <p className="mb-6 mt-1 text-[15px] text-neutral-500">Please fill out the form below and we'll get back to you as quickly as we can!</p>
          <EnquiryForm kind={career ? "career" : "contact"} extras={career ? [] : ["direction"]} submitLabel="Submit" testIdPrefix="contact"
            messagePlaceholder={career ? "Tell us about your experience and goals." : "Questions / comments"} />
        </div>
      </Container>
    </div>
  );
}
